"use client";

import type { QueryClient } from "@tanstack/react-query";

/**
 * Module-level handle on the app QueryClient so background work (uploads
 * that outlive the component that started them) can patch/invalidate caches.
 * Registered once by QueryProvider; readers must tolerate absence (tests,
 * early boot) and skip silently.
 */

let registered: QueryClient | null = null;

export const registerQueryClient = (client: QueryClient): void => {
  registered = client;
};

export const getQueryClient = (): QueryClient | null => registered;
